import { IPlayerState } from '../reducer.types';
import { showApiRequestFailure } from '../actions';

export const showApiRequestFailureReducer = (
  state: IPlayerState,
  action: ReturnType<typeof showApiRequestFailure>,
) => ({
  ...state,
  isShowApiRequestPending: false,
  showApiRequestErrorMessage: action.payload.errorMessage || '',
});
